module.exports = __webpack_public_path__ + "img/PScharactermark.b9ad512a.png";